import { render, staticRenderFns } from "./DFileUploadEditor.vue?vue&type=template&id=d547e584&"
import script from "./DFileUploadEditor.vue?vue&type=script&lang=js&"
export * from "./DFileUploadEditor.vue?vue&type=script&lang=js&"
import style0 from "./DFileUploadEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports